import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Row, Alert, Spinner } from 'react-bootstrap';
import FormBusca from './form_busca';
import DiarioService from '../../../services/diario'
import InfiniteScroll from '../../auth/utils/infiniteScroll';
import Diario from './diario';
import LeitorPDF from './leitorPDF';

const ListarDiarios = () => {


    async function fetchDiarios() {
        await seraQueAcabou();
        const response = await DiarioService.listar({ limit: true, cod_diario: cod });
        if (response.data.length >= 1) {
            let count = Math.floor(numDiarios / 20) + 1
            for (let i = 1; i < count; i++) {
                setDiarios([...diarios, ...response.data])
                setCod(response.data[response.data.length - 1]["cod_diario"])
                if (response.data.length < 20) {
                    setAindaTem(false)
                }
            }
        } else {
            setDiarios([])
            setVazio(true)
        }
    }

    const [diarios, setDiarios] = useState([]);
    const [vazio, setVazio] = useState(false);
    const [cod, setCod] = useState(null);
    const [numDiarios, setNumDiarios] = useState(null);
    const [aindaTem, setAindaTem] = useState();
    const [aguardando, setAguardando] = useState(true);
    const [pdfSelecionado, setPdfSelecionado] = useState(null);



    async function fetchDiariosIn() {
        await pegaNumDiarios();
        const response = await DiarioService.listar();
        if (response.data.length >= 1) {
            setDiarios(response.data)
            setVazio(false)
            setAguardando(false)
            setCod(response.data[response.data.length - 1]["cod_diario"])
            if (response.data.length == 20) {
                setAindaTem(true)
            } else {
                setAindaTem(false)
            }
        } else {
            setDiarios([])
            setVazio(true)
        }
    }

    async function pegaNumDiarios() {
        const response = await DiarioService.numDiarios({ todas: true })
        setNumDiarios(parseInt(response.data))
    }

    const seraQueAcabou = async () => {
        if (diarios.length >= numDiarios + 1) {
            setAindaTem(false)
        } else {
            setAindaTem(true)
        }
    }

    const handleLerDiario = (url) => {
        setPdfSelecionado(url);
    };

    const handleFecharLeitor = () => {
        setPdfSelecionado(null);
    };



    useEffect(() => {
        fetchDiariosIn();
    }, []);


    return (
        <Fragment>
            <Fragment>
                <FormBusca
                    setDiarios={setDiarios}
                    setVazio={setVazio}
                    setAguardando={setAguardando}
                    setAindaTem={setAindaTem}
                    fetchDiariosIn={fetchDiariosIn}
                    diarios={diarios}
                />
            </Fragment>
            {aguardando ?
                <Fragment>
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Carregando dados...</span>
                    </Spinner>
                    <Alert variant='warning'>Caso tenha feito uma busca usando palavra-chave, ela é demorada. Podendo levar de 1 a 5 minutos para ser executada. O motivo é: o sistema está lendo todos os PDF's de todos os diários para achar sua busca.
                        Para obter um resultado mais rápido, utilize também os campos de mês e ano.</Alert>
                </Fragment>
                :
                <Fragment>
                    {vazio ? <Fragment>
                        <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
                    </Fragment> :
                        <Fragment>
                            <Row xs={1}>
                                {diarios.map((diario, index) =>
                                    <Diario
                                        diario={diario}
                                        key={index}
                                        onLerDiario={handleLerDiario}
                                    />
                                )}
                                {pdfSelecionado && (
                                    <LeitorPDF file={pdfSelecionado} onClose={handleFecharLeitor} />
                                )}
                            </Row>
                            {aindaTem ?
                                <Fragment>
                                    <p>Carregando mais edições...</p>
                                    <InfiniteScroll Listar={fetchDiarios} />
                                </Fragment>
                                : <p>Todas as edições já foram exibidas :)</p>}
                        </Fragment>}
                </Fragment>}
        </Fragment>

    )
}

export default ListarDiarios;